import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-1 d-flex align-center"
}
const _hoisted_2 = { class: "text-h6 mb-2" }
const _hoisted_3 = {
  class: "text-body-2 text-center mb-0",
  style: {"max-width":"500px"}
}
const _hoisted_4 = { class: "text-h6 mb-2" }
const _hoisted_5 = {
  class: "text-body-2 text-center mb-6",
  style: {"max-width":"500px"}
}
const _hoisted_6 = {
  key: 0,
  class: "welcome-entrance d-flex flex-column align-center justify-center",
  style: {"min-height":"200px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ToolEventsPanel = _resolveComponent("ToolEventsPanel")!
  const _component_FormattingCard = _resolveComponent("FormattingCard")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_VideoToAgentDialog = _resolveComponent("VideoToAgentDialog")!
  const _component_WorkflowVideoReviewDialog = _resolveComponent("WorkflowVideoReviewDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showConfigChat,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showConfigChat) = $event)),
        _ctx.onDialogToggle
      ],
      "max-width": "800px",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "config-chat-card d-flex flex-column",
          height: "80vh"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "flex-shrink-0 d-flex align-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-robot-outline")
                  ])),
                  _: 1,
                  __: [8]
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Configuration Assistant", -1)),
                _createVNode(_component_v_spacer),
                (_ctx.configAgentReady)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_v_btn, {
                        icon: "mdi-video-plus-outline",
                        variant: "text",
                        size: "large",
                        disabled: _ctx.workflowReviewSubmitting || !_ctx.configAgentName,
                        title: "Video To Agent",
                        onClick: _ctx.openVideoToAgentDialog
                      }, null, 8, ["disabled", "onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.configAgentReady && _ctx.messages.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      icon: "mdi-delete-outline",
                      variant: "text",
                      size: "large",
                      loading: _ctx.clearingChat,
                      disabled: _ctx.clearingChat || _ctx.isStreaming,
                      title: "Clear chat",
                      onClick: _ctx.clearChat
                    }, null, 8, ["loading", "disabled", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  size: "small",
                  onClick: _ctx.closeChat
                }, null, 8, ["onClick"])
              ]),
              _: 1,
              __: [9]
            }),
            _createVNode(_component_v_divider),
            (_ctx.showConfigAgentPending)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "flex-grow-1 d-flex flex-column justify-center align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary",
                      class: "mb-4"
                    }),
                    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.configAgentPendingTitle), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.configAgentPendingMessage), 1)
                  ]),
                  _: 1
                }))
              : (_ctx.configAgentStatusError)
                ? (_openBlock(), _createBlock(_component_v_card_text, {
                    key: 1,
                    class: "flex-grow-1 d-flex flex-column justify-center align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "64",
                        color: "warning",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-alert-circle-outline")
                        ])),
                        _: 1,
                        __: [10]
                      }),
                      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-h6 mb-2" }, "Could not check Configuration Assistant", -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("p", {
                        class: "text-body-2 text-center mb-6",
                        style: {"max-width":"500px"}
                      }, " I could not confirm whether the assistant is ready yet. Please retry. ", -1)),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "outlined",
                        loading: _ctx.configAgentStatusLoading,
                        onClick: _ctx.onDialogOpen
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" Retry ")
                        ])),
                        _: 1,
                        __: [11]
                      }, 8, ["loading", "onClick"])
                    ]),
                    _: 1,
                    __: [12,13]
                  }))
                : (!_ctx.configAgentReady && _ctx.availableProviders.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_card_text, {
                      key: 2,
                      class: "flex-grow-1 d-flex flex-column justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "64",
                          color: "primary",
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode("mdi-robot-happy-outline")
                          ])),
                          _: 1,
                          __: [14]
                        }),
                        _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-h6 mb-2" }, "Set Up Configuration Assistant", -1)),
                        _cache[17] || (_cache[17] = _createElementVNode("p", {
                          class: "text-body-2 text-center mb-6",
                          style: {"max-width":"500px"}
                        }, " The configuration assistant helps you create agents, set up schedules, and manage tools. Select which AI model to use: ", -1)),
                        _createVNode(_component_v_radio_group, {
                          modelValue: _ctx.selectedProviderKey,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProviderKey) = $event)),
                          class: "w-100 px-4",
                          style: {"max-width":"400px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableProviders, (option) => {
                              return (_openBlock(), _createBlock(_component_v_radio, {
                                key: option.providerKey,
                                label: `${option.modelName} (${option.providerKey})`,
                                value: option.providerKey
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "outlined",
                          loading: _ctx.provisioning,
                          disabled: !_ctx.selectedProviderKey || _ctx.provisioning,
                          onClick: _ctx.provisionWithSelectedProvider,
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode(" Set Up Assistant ")
                          ])),
                          _: 1,
                          __: [15]
                        }, 8, ["loading", "disabled", "onClick"])
                      ]),
                      _: 1,
                      __: [16,17]
                    }))
                  : (!_ctx.configAgentReady)
                    ? (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 3,
                        class: "flex-grow-1 d-flex flex-column justify-center align-center"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.hasExistingProviders ? 'Set Up Configuration Assistant' : 'Set Up an AI Provider'), 1),
                          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.hasExistingProviders
              ? 'Select a provider to use for the configuration assistant. It helps you create agents, set up schedules, and manage tools.'
              : 'To get started, connect an AI provider. This will auto-provision the configuration assistant along with your first model and agent.'), 1),
                          _createVNode(_component_v_form, {
                            class: "w-100 px-4",
                            style: {"max-width":"400px"},
                            onSubmit: _withModifiers(_ctx.setupProvider, ["prevent"]),
                            autocomplete: "off"
                          }, {
                            default: _withCtx(() => [
                              _cache[18] || (_cache[18] = _createElementVNode("input", {
                                id: "username",
                                autocomplete: "username",
                                type: "text",
                                style: {"display":"none"}
                              }, null, -1)),
                              _cache[19] || (_cache[19] = _createElementVNode("input", {
                                id: "password",
                                autocomplete: "new-password",
                                type: "password",
                                style: {"display":"none"}
                              }, null, -1)),
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.providerKey,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.providerKey) = $event)),
                                items: _ctx.builtInProviders,
                                label: "Select Provider",
                                variant: "outlined",
                                density: "compact",
                                class: "mb-2"
                              }, null, 8, ["modelValue", "items"]),
                              (!_ctx.providerAlreadyConfigured)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    modelValue: _ctx.apiKey,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apiKey) = $event)),
                                    label: "API Key",
                                    type: "password",
                                    variant: "outlined",
                                    density: "compact",
                                    class: "mb-2",
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                block: "",
                                loading: _ctx.provisioning,
                                disabled: !_ctx.providerKey || (!_ctx.apiKey && !_ctx.providerAlreadyConfigured) || _ctx.provisioning,
                                onClick: _ctx.setupProvider
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.providerAlreadyConfigured ? 'Set Up Assistant' : 'Connect Provider'), 1)
                                ]),
                                _: 1
                              }, 8, ["loading", "disabled", "onClick"])
                            ]),
                            _: 1,
                            __: [18,19]
                          }, 8, ["onSubmit"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createVNode(_component_v_card_text, {
                          class: "chat-area flex-grow-1 overflow-y-auto",
                          ref: "chatArea"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(['chat-messages', { 'chat-fading-out': _ctx.chatFadingOut }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayMessages, (message, index) => {
                                return (_openBlock(), _createBlock(_component_v_row, {
                                  key: index,
                                  justify: message.role === 'user' ? 'end' : 'start',
                                  "no-gutters": "",
                                  class: "mb-4 chat-message-row",
                                  style: _normalizeStyle(_ctx.chatFadingOut ? { transitionDelay: `${index * 40}ms` } : {})
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      sm: "11"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["message-name text-caption mb-1", message.role === 'user' ? 'text-right' : 'text-left'])
                                        }, _toDisplayString(message.role === 'user' ? 'You' : 'Config Assistant'), 3),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["message-container", message.role === 'user' ? 'user-message' : 'assistant-message'])
                                        }, [
                                          (message.role === 'assistant')
                                            ? (_openBlock(), _createBlock(_component_ToolEventsPanel, {
                                                key: 0,
                                                "tool-events": message.toolEvents || [],
                                                "show-activity": _ctx.shouldShowToolActivity(message, index),
                                                compact: ""
                                              }, null, 8, ["tool-events", "show-activity"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_FormattingCard, {
                                            content: message.content,
                                            expanded: true,
                                            title: null,
                                            streaming: _ctx.streamingMessageIndex === index,
                                            class: "text-wrap text-break"
                                          }, null, 8, ["content", "streaming"])
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["justify", "style"]))
                              }), 128))
                            ], 2),
                            (_ctx.welcomeEntering)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  _createVNode(_component_v_icon, {
                                    size: "48",
                                    color: "primary",
                                    class: "welcome-icon mb-3"
                                  }, {
                                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                                      _createTextVNode("mdi-robot-happy-outline")
                                    ])),
                                    _: 1,
                                    __: [20]
                                  }),
                                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis welcome-text" }, "Starting fresh...", -1))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_v_divider),
                        _createVNode(_component_v_card_actions, { class: "flex-shrink-0 pa-3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              modelValue: _ctx.userInput,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userInput) = $event)),
                              placeholder: "Ask about setting up agents, schedules, tools...",
                              variant: "outlined",
                              density: "compact",
                              rows: "2",
                              "auto-grow": "",
                              "max-rows": "6",
                              "hide-details": "",
                              class: "flex-grow-1 mr-2",
                              onKeydown: _withKeys(_withModifiers(_ctx.sendMessage, ["exact","prevent"]), ["enter"]),
                              disabled: _ctx.isStreaming
                            }, null, 8, ["modelValue", "onKeydown", "disabled"]),
                            _createVNode(_component_v_btn, {
                              icon: "mdi-send",
                              color: "primary",
                              disabled: !_ctx.userInput.trim() || _ctx.isStreaming || !_ctx.configAgentName,
                              loading: _ctx.isStreaming,
                              onClick: _ctx.sendMessage
                            }, null, 8, ["disabled", "loading", "onClick"])
                          ]),
                          _: 1
                        })
                      ], 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_VideoToAgentDialog, {
      open: _ctx.showVideoToAgentDialog,
      processing: _ctx.workflowVideoActive,
      "processing-label": _ctx.workflowVideoStatusLabel,
      "error-message": _ctx.workflowVideoError,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showVideoToAgentDialog = $event)),
      onProcess: _ctx.processWorkflowVideo
    }, null, 8, ["open", "processing", "processing-label", "error-message", "onProcess"]),
    _createVNode(_component_WorkflowVideoReviewDialog, {
      open: _ctx.workflowReviewOpen,
      "model-value": _ctx.workflowReviewText,
      submitting: _ctx.workflowReviewSubmitting,
      "error-message": _ctx.workflowReviewError,
      "can-submit-to-current-chat": _ctx.canSubmitWorkflowReviewToCurrentChat,
      "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => (_ctx.workflowReviewOpen = $event)),
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.workflowReviewText = $event)),
      onSubmitToCurrentChat: _ctx.submitWorkflowReviewToCurrentChat,
      onSubmitToNewChat: _ctx.submitWorkflowReviewToNewChat,
      onDiscard: _ctx.discardWorkflowReview
    }, null, 8, ["open", "model-value", "submitting", "error-message", "can-submit-to-current-chat", "onSubmitToCurrentChat", "onSubmitToNewChat", "onDiscard"])
  ]))
}